// DEPRECATED: superseded by ScheduleTriggerV2. Kept so existing workflows
// using the old schedule trigger continue to render.
import { type LBNodeData } from '@/proto/logiblocks/logiblocks';
import { TRIGGER_ICON_COLOR } from '../../styles';
import {
  formatHourMinute,
  getDayOfWeekShortLabel,
  utcHourMinuteToUser,
  shiftDayOfWeek,
} from '../../dateTimeUtils';
import { getUserTimeZone } from '@/common/utils/utils';
import {
  type GraphData,
  type LBNodeInfo,
  NodeCategory,
  OutputType,
} from '../../types';
import { ScheduleTriggerCustomization } from './ScheduleTriggerCustomization';
import { ClockIcon } from '@/assets/icons/icons';
import { buildNodeData } from '../../nodeDataUtils';

/** Validation field names for the Schedule trigger. Shared with the UI. */
export const ScheduleTriggerFields = {
  SCHEDULE_TYPE: 'Schedule type',
} as const;

export const ScheduleTriggerNodeInfo: LBNodeInfo = {
  protobufNodeDataKey: 'schedule_trigger',

  category: NodeCategory.TRIGGER,

  label: 'Schedule',

  hasInput: false,

  getIcon: (size: number) => (
    <ClockIcon color={TRIGGER_ICON_COLOR} width={size} height={size} />
  ),

  outputType: OutputType.SINGLE,

  getSubtitle: (data: LBNodeData, _graph: GraphData) => {
    const schedule = data.schedule_trigger;
    if (!schedule) {
      return undefined;
    }

    const tz = getUserTimeZone();

    if (schedule.daily) {
      const { hour, minute } = utcHourMinuteToUser(
        schedule.daily.hour,
        schedule.daily.minute,
        tz.name
      );
      return `Daily at ${formatHourMinute(hour, minute)}`;
    }

    if (schedule.days_of_week) {
      const { hour, minute, dayOffset } = utcHourMinuteToUser(
        schedule.days_of_week.hour,
        schedule.days_of_week.minute,
        tz.name
      );
      const dayNames = schedule.days_of_week.days_of_week
        .map((d) => getDayOfWeekShortLabel(shiftDayOfWeek(d, dayOffset)))
        .join(', ');
      return `${dayNames} at ${formatHourMinute(hour, minute)}`;
    }

    return undefined;
  },

  getValidationErrors: (
    _nodeId: string,
    nodeData: LBNodeData,
    _graph: GraphData
  ) => {
    const schedule = nodeData.schedule_trigger;
    if (!schedule?.daily && !schedule?.days_of_week) {
      return [
        {
          type: 'REQUIRED_FIELD',
          field: ScheduleTriggerFields.SCHEDULE_TYPE,
          message: 'Schedule type must be configured',
        },
      ];
    }
    return undefined;
  },

  CustomizationComponent: ScheduleTriggerCustomization,

  createDefaultNodeData: () =>
    buildNodeData('schedule_trigger', { daily: { hour: 9, minute: 0 } }),
};
